// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import 'bulmaswatch/flatly/bulmaswatch.min.css'

import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

import DateFilter from '@/filters/DateFilter'
Vue.filter('formatDate', DateFilter)

import * as GmapVue from 'gmap-vue'
Vue.use(GmapVue, {
  load: {
    libraries: 'geometry',
    // key: process.env.GOOGLE_MAPS_KEY,
    key: '{{GOOGLE_MAPS_KEY}}',
  },
  installComponents: true
})

import { datadogLogs } from '@datadog/browser-logs'

if (window.location.origin.includes('cannveya.com')) {
  datadogLogs.init({
    clientToken: 'pubc6af2ed850fe3283e352e8debc8e0ea7',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    service: 'dispatch-components',
    trackSessionAcrossSubdomains: true,
    beforeSend: (log) => {
    },
  })
}


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js